import React from "react";
import './DatePicker.css';

interface IDatePickerProps{

}

export const DatePicker = ({}: IDatePickerProps)=>{
    const week = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
    const month = new Array(31).fill(0).map((it, i)=> i + 1);
    const selectedStart = 3;
    const selectedEnd = 15;
    return <div className={`commonDatePicker ${true ? 'commonDatePicker--opened': ''}`}>
        <div className="commonDatePicker_head">
            <div className="button commonDatePicker_today">
                Today
            </div>
            <div className="commonDatePicker_dropMonth">
                June
            </div>
            <div className="commonDatePicker_arrows">
                <div className="button commonDatePicker_arrow commonDatePicker_arrow_left">
                    l
                </div>
                <div className="button commonDatePicker_arrow commonDatePicker_arrow_right">
                    r
                </div>
            </div>
        </div>
        <div className="commonDatePicker_week">
            {week.map((it, i)=>{
                return <div className="commonDatePicker_cell commonDatePicker_cell_week">{it}</div>
            })}
        </div>
        <div className="commonDatePicker_month">
            {month.map((it, i)=>{
                return <div className={"commonDatePicker_cell commonDatePicker_cell_month " + (i==selectedStart ? "commonDatePicker_cell--selectedStart " : "") + (i==selectedEnd ? "commonDatePicker_cell--selectedEnd " : "") + ((i>selectedStart && i<selectedEnd) ? "commonDatePicker_cell--range " : "")}>{it}</div>
            })}
        </div>

        <div className="commonDatePicker_buttons">
            <div className="button commonDatePicker_button commonDatePicker_button_cancel">
                Cancel
            </div>
            <div className="button commonDatePicker_button commonDatePicker_button_apply">
                Apply
            </div>
        </div>
    </div>
}